import { FinancialMapper } from "@/domain/mappers";
import { Financial, Payout } from "@/domain/entities";
import { FinancialRepository } from "@/domain/repositories";
import { FinancialDataSource } from "../datasources/financial/FinancialDataSource";
import { FinancialResponse, PayoutResponse } from "../dtos/responses";

export class FinancialRepoImpl implements FinancialRepository {
  constructor(
    private readonly dataSource: FinancialDataSource,
    private readonly financialMapper: FinancialMapper<
      FinancialResponse,
      PayoutResponse
    >,
  ) {}

  async getFinancial(query: {
    date_start: string;
    date_end: string;
  }): Promise<Financial> {
    const data = await this.dataSource.getFinancial(query);

    return this.financialMapper.toDomain(data);
  }

  async getPayoutById(id: number): Promise<Payout> {
    const data = await this.dataSource.getPayoutById(id);
    return this.financialMapper.toPayoutDomain(data);
  }
}
